var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ad._id)?_c('div',{staticClass:"wrap",style:(_vm.styl)},[_c('a',{attrs:{"target":"_blank","href":_vm.ad.url}},[_c('img',{attrs:{"src":_vm.ad.bgimage},on:{"click":function($event){return _vm.statistics('click')}}})]),(_vm.ad.showType != '活动')?_c('div',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("广告")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }